import { fetchAPI } from 'api';

export const closeAccount = async () => {
  return await fetchAPI('account-closures', {
    method: 'POST',
  });
};
